export default {
  'profile.updatesuccess': 'تم تحديث ملفك الشخصي بنجاح',
  'profile.insertsuccess': 'تم إنشاء ملفك الشخصي بنجاح',
  'profile.profile': 'الملف الشخصي',
  'profile.search': 'بحث',
  'profile.oldpassword': 'كلمة المرور القديمة',
  'profile.newpassword': 'كلمة المرور الجديدة',
  'profile.logo': 'شعار',
  'profile.workinghours': 'ساعات العمل',
  'profile.nationalcardfile': 'ملف البطاقة الوطنية',
  'profile.addfile': 'إضافة ملف',
  'profile.editinformation': 'تحرير معلومات الملف الشخصي',
  'profile.email': 'البريد الإلكتروني',
  'profile.weekdays': 'أيام الأسبوع',
  'profile.close': 'إغلاق',
  'profile.savechanges': 'حفظ التغييرات',
  'profile.deleteconfirmation': 'هل أنت متأكد من الحذف؟',
  'profile.rolename': 'اسم الدور',
  'profile.register': 'تسجيل',
  'profile.delete': 'حذف',
  'profile.addemployee': 'إضافة موظف جديد',
  'profile.deleteemployee': 'حذف الموظف',
  'profile.cancel': 'إلغاء',
  'profile.number': 'الرقم',
  'profile.fromtime': 'من الوقت',
  'profile.totime': 'إلى الوقت',
  'profile.setworkinghours': 'تعيين ساعات العمل',
  'profile.phone': 'الهاتف',
  'profile.selectyear': 'اختر سنة الميلاد',
  'profile.selectmonth': 'اختر شهر الميلاد',
  'profile.selectday': 'اختر يوم الميلاد',
  'profile.address': 'العنوان',
  'profile.companyname': 'اسم الشركة',
  'profile.englishcompanyname': 'اسم الشركة بالإنجليزية',
  'profile.persiancompanyname': 'اسم الشركة باللغة المحلية',
  'profile.webSite': 'الموقع الإلكتروني',
  'profile.removeaddress': 'إزالة العنوان',
  'profile.moreaddress': 'إضافة عنوان',
  'profile.removephone': 'إزالة الهاتف',
  'profile.addphone': 'إضافة هاتف',
  'profile.registercode': 'رمز التسجيل',
  'profile.managername': 'اسم المدير/الوكيل (مطلوب)',
  'profile.businessmanagername': 'اسم المدير',
  'profile.type': 'نوع العمل (مطلوب)',
  'profile.businesstype': 'نوع العمل',
  'profile.licensefile': 'ملف الترخيص',
  'profile.updatepassword': 'يرجى تحديث كلمة المرور للمتابعة',
  'profile.editprofile': 'تحرير ملف العمل',
  'profile.individualprofile': 'تحرير الملف الشخصي',
  'profile.inviteemployee': 'دعوة موظف',
  'profile.change': 'تغيير',
  'profile.firstname': 'الاسم الأول',
  'profile.lastname': 'اسم العائلة',
  'profile.mobile': 'الجوال',
  'profile.nationalcode': 'الرقم الوطني',
  'profile.password': 'كلمة المرور',
  'profile.username': 'اسم المستخدم',
  'profile.username/email': 'اسم المستخدم / البريد الإلكتروني',
  'profile.gender': 'الجنس',
  'profile.birthdate': 'تاريخ الميلاد',
  'profile.selectavatar': 'اختر الصورة الرمزية',
  'profile.adminitstrator': 'مدير نظام',
  'profile.book/reserve': 'الحجز',
  'profile.changepassword': 'تغيير كلمة المرور',
  'profile.editpersonalprofile': 'تحرير الملف الشخصي',
  'profile.onlinesupport': 'الدعم الفني عبر الإنترنت',
  'profile.employees': 'الموظفين',
  'profile.addprofile': 'إضافة ملف عمل جديد',
  'profile.addbusiness': 'إضافة عمل',
  'profile.encompanyname': 'اسم الشركة بالإنجليزية (مطلوب)',
  'profile.facompanyname': 'اسم الشركة باللغة المحلية (مطلوب)',
  'profile.myprofile': 'ملفي الشخصي',
  'profile.employeemanagement': 'إدارة الموظفين',
  'profile.airlinequota': 'حصة الطيران',
  'profile.signiture': 'توقيع الملف الشخصي',
  'profile.addsigniture': 'حفظ التوقيع',
  'profile.quotaadd': 'تمت إضافة الحصة بنجاح',
  'profile.signout': 'تسجيل الخروج',
  'profile.signituresave': 'تم حفظ التوقيع بنجاح',
  'profile.signitureerror': 'يرجى المحاولة مرة أخرى',
  'profile.profiletype': 'اختر نوع الملف الشخصي',
  'profile.profilsend':
    'تم إرسال الملف الشخصي للتحقق. سيتم الإعلان عن النتائج قريبًا',

  'profile.suspend': 'تعليق',
  'profile.nationalid': 'الرقم الوطني (مطلوب)',
  'profile.businessnationalid': 'الرقم الوطني',
  'profile.activitycode': 'رمز النشاط (مطلوب)',
  'profile.economiccode': 'الرمز الاقتصادي (مطلوب)',
  'profile.businessactivitycode': 'رمز النشاط',
  'profile.businesseconomiccode': 'الرمز الاقتصادي',
  'profile.choosegateway': 'اختر البوابة',
  'profile.testconnection': 'اختبار الاتصال',
  'profile.savesigniture': 'حفظ التوقيع',
  'profile.signitureping': 'تم إرسال تجربة البوابة بنجاح',
  'profile.country': 'البلد',
  'profile.city': 'المدينة',
  'profile.role': 'الدور',
  'profile.whoareyou': 'من أنت؟',
  'profile.license': 'إضافة ترخيص',
  'profile.licenses': 'التراخيص',
  'profile.removelicense': 'إزالة الترخيص',
  'profile.addlicense': 'إضافة ترخيص',
  'profile.licensetype': 'النوع',
  'profile.upload': 'تحميل',
  'profile.completeprofilepoint': 'لكسب النقاط، يرجى استكمال ملفك الشخصي',

  // "profile.completeprofilepoint2": "point , please complete your point",
  'profile.licenseno': 'رقم الترخيص',
  'profile.addresswithoutindex': 'العنوان',
  'profile.phonewithoutindex': 'الهاتف',
  'profile.underprocess': 'تحت العملية',
  'profile.fullname': 'الاسم الكامل',
  'profile.airlinemarkup': 'زيادة سعر الطيران',
  'profile.airlinename': 'اسم الطيران',
  'profile.airlinetype': 'نوع الطيران',
  'profile.quota': 'الحصة',
  'profile.markup': 'الزيادة',
  'profile.savequota': 'حفظ الحصة',
  'profile.currency': 'العملة',
  'profile.passportNumber': 'رقم الجواز',
  'profile.userPointType': 'نوع النقاط',
  'profile.point': 'النقاط',
  'profile.savepoint': 'حفظ النقاط',
  'profile.userpoint': 'نقاط المستخدم',
  'profile.subject': 'الموضوع',
  'profile.date': 'تاريخ التعيين',
  'profile.totaluserpoint': 'إجمالي نقاط المستخدم',
  'profile.viewdetails': 'عرض التفاصيل',
  'profile.provider': 'مزود الخدمة',
  'profile.b2brequest': 'طلب الخدمة',
  'profile.language': 'اللغة',
  'profile.department': 'القسم',
  'profile.adddetail': 'إضافة المزيد من التفاصيل (اختياري)',
  'profile.identityno': 'رقم الهوية',
  'profile.gateway': 'البوابة',
  'profile.hi': 'مرحبًا',
  'profile.status': 'الحالة',
  'profile.copy': 'نسخ',
  'profile.approve': 'الموافقة',
  'profile.agree': 'موافق',
  'profile.dissapprove': 'رفض',
  'profile.pending': 'قيد الانتظار',
  'profile.notexitstuser': 'هذا الاسم المستخدم غير موجود',
  'profile.selectrole': 'الرجاء تحديد الدور والقسم',
  'profile.invitesuccessfully': 'تم إرسال الدعوة بنجاح',
  'profile.description': 'الوصف',
  'profile.filldescription': 'الرجاء إدخال الوصف',
  'profile.dashboard': 'لوحة التحكم',
  'profile.mydashboard': 'لوحة تحكمي',
  'profile.saleaccounting': 'تقارير المبيعات',
  'profile.profileaccounts': 'إدارة الحسابات',
  'profile.commissionmanagement': 'إدارة العمولة',
  'profile.uploadlogo': 'تحميل شعار الشركة الخاص بك',
  'profile.uploadlicense': 'تحميل الترخيص الخاص بك',
  'profile.deleteprofile': 'حذف الملف الشخصي',
  'profile.viewlicense': 'عرض التراخيص',
  'profile.licensepic': 'صورة الترخيص',
  'profile.airlineCommission': 'إدارة عمولة / زيادة أسعار الطيران',
  'profile.errordelete': 'لا يمكن حذف هذا السجل',
  'profile.editverification': 'هل أنت متأكد من تعديل هذا الملف الشخصي؟',
  'profile.reference': 'مرجع المصدّر',
  'profile.logotitle': 'انقر على الخيار أدناه لتحرير شعار الشركة',
  'profile.invitedepartment': 'عزيزي المستخدم، تمت دعوتك إلى ',
  'profile.inviteprofile': ' في قسم ',
  'profile.inviterole': ' في ملف تعريف الأعمال بموقع ',
  'profile.invite': '.إذا كنت ترغب، يرجى تأكيد الدعوة',
  'profile.countercommission': 'عمولة العداد',
  'profile.ownercommission': 'عمولة المالك',
  'profile.bankaccounttype': 'نوع الحساب البنكي',
  'profile.newQuota': 'حصة جديدة',
  'profile.commission': 'عمولة الملف الشخصي',
  'profile.addQuota': 'إضافة حصة',
  'profile.customermanagement': 'إدارة العملاء',
  'profile.active': 'نشط',
  'profile.disactive': 'إلغاء التنشيط',
  'profile.Individual': 'فردي',
  'profile.bussiness': 'تجاري',
  'profile.postalcode': 'الرمز البريدي',
  'profile.fax': 'فاكس',
  'profile.accountingcode': 'رمز المحاسبة',
  'profile.deletecustomer': 'حذف العميل',
  'profile.insertcustomer': 'إدراج العميل',
  'profile.updatecustomer': 'تحديث العميل',
  'profile.both': 'كلاهما',
  'profile.reload': 'إعادة تحميل',
  'profile.reloadfilter': 'إعادة تحميل الفلتر',
  'profile.isbusiness': 'هل هو تجاري',
  'profile.isactive': 'هل هو نشط',
  'profile.name': 'الاسم',
  'profile.registerdate': 'تاريخ التسجيل',
  'profile.chargewallet': 'شحن المحفظة',
  'profile.currentcredit': 'الرصيد الحالي',
  'profile.amount': 'مبلغ الشحن',
  'profile.chargecreditmessgae': 'قم بشحن محفظتك للشراء بسهولة وأمان.',
  'profile.credit': 'الرصيد:',
  'profile.paymentdate': 'تاريخ الدفع',
  'profile.businessbooking': 'طلباتي',
  'profile.gotpage': 'العودة إلى صفحة شحن المحفظة',
  'profile.notfound': 'لم يتم العثور على سجلات!!!',
  'profile.message': 'الرسالة',
  'profile.mypoint': 'نقاطي',
  'profile.pointtransaction': 'عملية نقاط',
  'profile.buypoints': 'شراء النقاط',
  'profile.wallet': 'المحفظة',
  'profile.chooseRole': 'اختر دورًا',
  'profile.mycredit': 'رصيدي',
  'profile.tourManagement': 'إدارة الجولات',
  'profile.departmentmanagement': 'إدارة الأقسام',
  'profile.customerphrase': 'الاسم الكامل / رمز المحاسبة',
  'profile.enterusername': 'أدخل اسم المستخدم المطلوب',
  'profile.menucredit': 'الرصيد:',
  'profile.personalprofile': 'الملف الشخصي الفردي',
  'profile.employeesearch': 'البحث حسب الاسم الأول والاسم الأخير والجوال',
  'profile.gotowalletpage': 'العودة إلى صفحة شحن المحفظة',
  'profile.documentdescription': 'وصف الوثيقة',
  'profile.documentnumber': 'رقم الوثيقة',
  'profile.registertime': 'وقت التسجيل',
  'profile.price': 'السعر (ريال إيراني)',
  'profile.errorsecondpassword':
    'كلمة المرور الثانية وتكرار كلمة المرور الثانية غير متطابقين',
  'profile.successsecondpassword': 'تم حفظ كلمة المرور الثانية بنجاح',
  'profile.nowheretoursmanagement': 'إدارة الجولات في كل مكان',
  'profile.insertinformation': 'إدراج المعلومات',
  'profile.businessprofile': 'الملف الشخصي للشركة',
  'profile.creditmanagement': 'إدارة الائتمان',
  'profile.affiliateMarketing': 'التسويق بالعمولة',
  'profile.account': 'الحساب',
  'profile.individual': 'فردي',
  'profile.business': 'عمل',
  'profile.myfriends': 'أصدقائي',
  'profile.viewCreditsAndWallets': 'عرض الاعتمادات والمحافظ',
  'profile.employeeManagement': 'إدارة الموظفين',
  'profile.customerManagement': 'إدارة العملاء',
  'profile.transferType': 'نوع التحويل',
  'profile.employeeList': 'قائمة الموظفين',
  'profile.addEmployee': 'إضافة موظف',
  'profile.sendingInvitation': 'إرسال دعوة',
  'profile.employee': 'موظف',
  'profile.call': 'اتصال',
  'profile.message': 'رسالة',
  'profile.increaseOrEditCredentials': 'زيادة أو تحرير الاعتمادات',
  'profile.financialmanagement': 'إدارة مالية',
  'profile.messagedate': 'تاريخ الرسالة',
  'profile.startMessagedate': 'تاريخ بدء الرسالة',
  'profile.endMessagedate': 'تاريخ انتهاء الرسالة',
  'profile.pointsremain': 'النقاط المتبقية',
  'profile.transaction': 'المعاملات',
  'profile.messagedescription': 'وصف الرسالة',
  'profile.addCustomer': 'إضافة عميل',
  'profile.profileedit': 'تحرير الملف الشخصي',
  'profile.upgradeYourPlan': 'تحديث خطتك',
  'profile.planCustomer': 'عميل الخطة',
  'profile.walletremain': 'المحفظة المتبقية',
  'profile.walletbalance': 'رصيد المحفظة',
  'profile.chargeamount': 'مبلغ الشحن (ريال إيراني)',
  'profile.bankreceipt': 'إيصال البنك',
  'profile.online': 'عبر الإنترنت',
  'profile.increasebalance': 'زيادة الرصيد',
  'profile.selectedbills': 'الفواتير المحددة',
  'profile.paymentbills': 'فواتير الدفع',
  'profile.sendToGroup': 'إرسال إلى المجموعة',
  'profile.theDesiredRole': 'الدور المطلوب',
  'profile.addDepartment': 'إضافة قسم',
  'profile.employeeRole': 'دور الموظف',
  'profile.moreDetails': 'المزيد من التفاصيل',
  'profile.mehdiAbdollahiMehr': 'مهدي عبداللهي مهر',
  'profile.hiMessage': 'مرحبًا، أين أنت؟',
  'profile.inWork': 'قيد العمل',
  'profile.addNew': 'إضافة جديد',
  'profile.reminding': 'تذكير',
  'profile.participate': 'المشاركة',
  'profile.sportsInteractive': 'تفاعل رياضي',
  'profile.team': 'الفريق',
  'profile.tasks': 'المهام',
  'profile.chooseAnArtist': 'اختيار فنان',
  'profile.prepareForACallWithAClient': 'الاستعداد لمكالمة مع العميل',
  'profile.prepareAEKTemplateForTheClient': 'إعداد قالب AEK للعميل',
  'profile.prepareDetiledBrief': 'إعداد موجز مفصل للمطورين والمصممين',
  'profile.more': 'المزيد',
  'profile.position': 'المنصب',
  'profile.employeeInformation': 'معلومات الموظف',
  'profile.employeeRegistrationDate': 'تاريخ تسجيل الموظف',
  'profile.creditAmount': 'مبلغ الائتمان',
  'profile.theCeilingOfEachPurchase': 'سقف كل عملية شراء',
  'profile.validityDuration': 'مدة الصلاحية',
  'profile.creditStatus': 'حالة الائتمان',
  'profile.increaseCredit': 'زيادة الائتمان',
  'profile.editCredit': 'تحرير الائتمان',
  'profile.employeeCredit': 'ائتمان الموظف',
  'profile.creditBalance': 'رصيد الائتمان',
  'profile.aboutme': 'عني',
  'profile.myfavouritecity': 'مدني المفضلة',
  'profile.transferamount': 'مبلغ التحويل',
  'profile.loan': 'قرض',
  'profile.gift': 'هدية',
  'profile.messageType': 'نوع الرسالة',
  'profile.text': 'نص',
  'profile.file': 'ملف',
  'profile.customerList': 'قائمة العملاء',
  'profile.totalPurchaseAmount': 'إجمالي مبلغ الشراء',
  'profile.topCustomers': 'أهم العملاء',
  'profile.homeAppliancesSeller': 'بائع أجهزة منزلية',
  'profile.pointsInventory': 'جرد النقاط',
  'profile.pointCard': 'بطاقة النقاط',
  'profile.shoppingList': 'قائمة التسوق',
  'profile.purchases': 'المشتريات',
  'profile.customerInformation': 'معلومات العميل',
  'profile.customerRegistrationDate': 'تاريخ تسجيل العميل',
  'profile.customerShoppingList': 'قائمة تسوق العميل',
  'profile.incomeFromTheCustomer': 'الدخل من العميل',
  'profile.companyAddress': 'عنوان الشركة',
  'profile.nameOfCEO': 'اسم الرئيس التنفيذي',
  'profile.registration/priceChange': 'تسجيل / تغيير السعر',
  'profile.printPassengerInvoice': 'طباعة فاتورة الراكب',
  'profile.registrationPaymentReceipts': 'تسجيل إيصالات الدفع',
  'profile.priceToBuyFromOwner': 'سعر الشراء من تريبسي',
  'profile.salesPriceCustomer': 'سعر البيع للعميل',
  'profile.salesManager': 'مدير المبيعات',
  'profile.showLess': 'عرض أقل',
  'profile.purchaseRate': 'معدل الشراء',
  'profile.changeTicketSalesRates': 'تغيير أسعار بيع التذاكر',
  'profile.savePrice': 'حفظ السعر',
  'profile.remainingAmount': 'المبلغ المتبقي',
  'profile.firstPayment': 'الدفعة الأولى',
  'profile.settlementOfTickets': 'تسوية التذاكر',
  'profile.totalAmount': 'المبلغ الإجمالي',
  'profile.attachedPaymentReceipt': 'إيصال الدفع المرفق',
  'profile.attachedPaymentReceipt1': 'الإيصال المرفق الأول',
  'profile.attachedPaymentReceipt2': 'الإيصال المرفق الثاني',
  'profile.attachedPaymentReceipt3': 'الإيصال المرفق الثالث',
  'profile.attachedPaymentReceipt4': 'الإيصال المرفق الرابع',
  'profile.attachedPaymentReceipt5': 'الإيصال المرفق الخامس',
  'profile.totalRemaining': 'المتبقي الإجمالي',
  'profile.saveAndNextReceipt': 'حفظ والتالي إيصال',
  'profile.saveAndExit': 'حفظ والخروج',
  'profile.editEmployeeInformation': 'تحرير معلومات الموظف',
  'profile.travel': 'السفر',
  'profile.editconfirmation':
    'من خلال تقديم طلب تحرير، سيتم تعليق ملفك الشخصي حتى يتم الموافقة عليه من قبل Tripsi. هل توافق؟',
  'profile.searchtobuy': 'البحث للشراء',
  'profile.listOfPassengers': 'قائمة الركاب',
  'profile.me': 'حدثنا عن نفسك. احصل على نقاط',
  'profile.customer': 'الزبون',
  'profile.addcity': 'إضافة مدينة',
  'profile.showinfo': 'عرض المعلومات',
  'profile.editPassengerInformation': 'تحرير معلومات الراكب',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    'تم تسجيل الراكب الخاص بك بنجاح',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    'تم تحرير معلومات الراكب المطلوب بنجاح',
  'profile.customerSuccessfullyRegistered': 'تم تسجيل العميل بنجاح',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    'تم تحرير معلومات العميل المطلوب بنجاح',
  'profile.addfriend': 'إضافة صديق',
  'profile.inveitefriend': 'دعوة الأصدقاء',
  'profile.inviteEmployees': 'دعوة الموظفين',
  'profile.addEmployees': 'إضافة موظفين',
  'profile.textLicense':
    'على هذه الصفحة يمكنك رؤية تراخيص الوكالة التي ترغب فيها.',
  'profile.textEmployees':
    'من خلال النموذج أدناه ، يمكنك إرسال دعوات إلى الموظفين الذين غادروا الشركة ولديهم أسماء مستخدمين نشطة.',
  'profile.textCustomer':
    'من خلال النموذج التالي ، يمكنك إضافة العملاء المطلوبين إلى المجموعة من خلال إكمال المعلومات التالية.',
  'profile.textAddemplo':
    'من خلال النموذج أدناه ، يمكنك إضافة موظفين جدد إلى الشركة ومراقبة أدائهم من خلال ميزات مختلفة في النظام.',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    'تم تسجيل الراكب الخاص بك بنجاح',
  'profile.uploadText':
    'على هذه الصفحة ، يمكنك تحميل الملف الشخصي المطلوب بالنقر على الرابط أدناه.',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    'تم تحرير معلومات الراكب المطلوبة بنجاح',
  'profile.customerSuccessfullyRegistered': 'تم تسجيل العميل بنجاح',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    'تم تحرير معلومات العميل المطلوب بنجاح',
  'profile.editEmployeeSuccessfully': 'تحرير معلومات الموظف بنجاح',
  'profile.updateEmployeeSuccess': 'تم تحرير معلومات الموظف بنجاح',
  'profile.mostSales': 'أكثر مبيعات',
  'profile.theLowestNumberOfSales': 'أقل عدد مبيعات',
  'profile.mostSalesAmount': 'أكبر مبلغ مبيعات',
  'profile.theLowestSalesAmount': 'أقل مبلغ مبيعات',
  'profile.mostActivityTime': 'أكثر وقت نشاط',
  'profile.minimumActivityTime': 'أقل وقت نشاط',
  'profile.employeeActivities': 'أنشطة الموظفين',
  'profile.applyChanges': 'تطبيق التغييرات',
  'profile.planPassenger': 'خطة الراكب',
  'profile.all': 'الكل',
  'profile.Activities': 'الأنشطة',
  'profile.allProfiles': 'الملفات الشخصية',
  'profile.allStatuses': 'جميع الحالات',
  'profile.dragtoadd': 'اسحب للإضافة',
  'profile.dragtotransfer': 'اسحب للنقل',
  'profile.alltransactions': 'جميع المعاملات',
  'profile.changedate': 'تغيير التاريخ',
  'profile.startTravelDate': 'تاريخ بدء السفر',
  'profile.endTravelDate': 'تاريخ انتهاء السفر',
  'profile.employeeSelection': 'اختيار الموظف',
  'profile.sendMessage': 'إرسال رسالة',
  'profile.groupSending': 'إرسال جماعي',
  'profile.showDetails': 'عرض التفاصيل',
  'profile.editingInformation': 'تحرير المعلومات',
  'profile.changeLogo': 'تغيير الشعار',
  'profile.allocation': 'تخصيص',
  'profile.allusers': 'جميع المستخدمين',
  'profile.onlineFriend': 'أصدقائي المتصلون',
  '20 people online': 'أشخاص متصلون',
  'profile.recentTravels': 'الرحلات الأخيرة',
  'profile.mounthReport': 'تقرير أداء الشهر الأخير',
  'profile.recentNews': 'أخبار حديثة',
  'profile.tourismNews': 'أخبار السياحة',
  'profile.recentMonthActivitie': 'أنشطة الشهر الأخير',
  'profile.NumberFlightPurchases': 'عدد عمليات شراء التذاكر',
  'profile.NumberFlightSearches': 'عدد عمليات البحث عن رحلات الطيران',
  'profile.services': 'خدماتنا',
  'profile.donutChart': 'الرحلات المنجزة',
  'profile.presensnt': 'حاضر',
  'profile.absence': 'غياب',
  'profile.leave': 'إجازة',
  'profile.activeTour': 'الرحلات النشطة',
  'profile.finishedTour': 'الرحلات المنتهية',
  'profile.createTour': 'إنشاء رحلة',
  'profile.choose': 'اختر',
  'profile.increaseCredit': 'زيادة الائتمان',
  'profile.textIncrease': 'يمكنك زيادة رصيدك من خلال النموذج أدناه.',
  'profile.textEditingTripsi':
    'يمكنك تغيير معلومات ملفك الشخصي من خلال النموذج أدناه ويرجى ملاحظة أنه بعد تغيير الملف الشخصي ، سيتم تعليقه ليتم الموافقة عليه من قبل Tripsi.',
  'profile.textEditingTripord':
    'يمكنك تغيير معلومات ملفك الشخصي من خلال النموذج أدناه ويرجى ملاحظة أنه بعد تغيير الملف الشخصي ، سيتم تعليقه ليتم الموافقة عليه من قبل Tripord.',
  'profile.textPassword':
    'يمكنك تغيير كلمة المرور الخاصة بك وتعريف كلمة مرور جديدة من خلال النموذج أدناه.',
  'profile.reservations': 'الحجوزات',
  'profile.row': 'صف',
  'profile.transactions': 'المعاملات',
  'profile.searchHistory': 'سجل البحث',
  'profile.Transactions': 'المعاملات',
  'profile.Invoices': 'الفواتير',
  'profile.assetManagment': 'إدارة الأصول',
  'profile.transaction': 'معاملة',
  'profile.Invoice': 'فاتورة',
  'profile.Credit': 'ائتمان',
  'profile.myProfile': 'ملفي الشخصي',
  'profile.textProfile': 'في هذا القسم يمكنك رؤية معلومات ملفك الشخصي.',
  'profile.textAddfriend':
    'يمكنك إرسال دعوة لأصدقائك من خلال النموذج التالي وإضافتهم إلى قائمة أصدقائك.',
  'profile.textFriend':
    'من خلال النموذج أدناه ، يمكنك إدخال معلومات أصدقائك وتسجيل المعلومات في النهاية.',
  'profile.textDepartment':
    'يمكنك تسجيل أو إعادة توجيه القسم المطلوب من خلال النموذج أدناه.',
  'profile.Invite': 'دعوة',
  'profile.add': 'إضافة',
  'profile.passengers': 'الركاب',
  'profile.messages': 'الرسائل',
  'profile.Services': 'الخدمات',
  'profile.Info': 'المعلومات',
  'profile.transportation': 'النقل',
  'profile.inhabitancy': 'الإقامة',
  'profile.facilities': 'المرافق',
  'profile.pricing': 'التسعير',
  'profile.clubCard': 'بطاقة النادي',
  'profile.messageNo': 'رقم الرسالة',
  'profile.viewInvoice': 'عرض الفاتورة',
  'profile.loading': 'جار التحميل...',
  'profile.moreAddressees': 'عرض المزيد من العناوين',
  'profile.morePhoneNumbers': 'عرض المزيد من أرقام الهاتف',
  'profile.flight': 'رحلة',
  'profile.paid': 'مدفوع',
  'profile.unpaid': 'غير مدفوع',
  'profile.choosefile': 'اختيار ملف',
  'profile.sellername': 'اسم البائع',
  'profile.factoreno': 'رقم الفاتورة',
  'profile.customername': 'اسم العميل',
  'profile.phonenumber': 'رقم الهاتف المحمول',
  'profile.printinvoice': 'طباعة الفاتورة',
  'profile.signature': 'ختم المحاسبة والتوقيع',
  'profile.signaturetext': 'بدون ختم وتوقيع ، المحاسبة غير صالحة.',
  'profile.servicedescription': 'وصف الخدمة',
  'profile.taxesduties': 'الضرائب والرسوم',
  'profile.purchaseamount': 'مبلغ الشراء',
  'profile.friendsearch': 'الاسم ، الرقم الوطني ، رقم الجواز',
  'profile.ticketsearch': 'العنوان ، رقم التذكرة',
  'profile.messagesearch': 'الموضوع ، رقم الرسالة',
  'profile.bookingflightsearch': 'الاسم ، رقم الطلب',
  'profile.transactionsearch': 'الاسم ، رقم الطلب',
  'profile.employeesearch': 'الاسم ، البريد الإلكتروني',
  'profile.customersearch': 'اسم العميل',
  'profile.passangersearch': 'الاسم ، الرقم الوطني ، رقم الجواز',
  'profile.activities': 'الأنشطة',
  'profile.addlicenselink': 'إضافة ترخيص',
  'profile.startnewsevent': 'بدء الحدث',
  'profile.endnewsevent': 'نهاية الحدث',
  'profile.descriptionnews': 'نص الخبر:',
  'profile.introduction': 'مقدمة',
  'profile.firsttravel': 'في انتظار الرحلة الأولى...',
  'profile.transactionnumber': 'رمز المعاملة:',
  'profile.notfoundnews': 'الأخبار غير موجودة',
  'profile.notfoundtravel': 'لم تسافر بعد.',
  'profile.waitingTrip': 'نحن في انتظار رحلتك الأولى...',
  'profile.addLicenseText':
    'من خلال النموذج أدناه ، يمكنك إدخال الأذونات الخاصة بك وتسجيل المعلومات في النهاية.',
  'profile.simpleuser': 'مستخدم عادي',
  'profile.owner': 'مالك',
  'profile.crm': 'إدارة علاقات العملاء',
  'profile.counter': 'المكتب',
  'profile.accountants': 'محاسبون',
  'profile.roles': 'الأدوار',
  'profile.backgammon': 'الخيل',
  'profile.chatgpt': 'chat gpt',
  'profile.calendar': 'التفاصيل',
  'profile.game': 'لعبة',
  'profile.viewfile': 'استعراض الملف',
  'profile.paymentdescription':
    'في هذا القسم، يمكنك دفع مشترياتك على عدة أقساط عن طريق تحميل إيصال الدفع الخاص بك.',
  'profile.paymentprice': 'مستحق السداد',
  'profile.addgateway': 'إضافة مسار طيران',
  'profile.editgateway': 'تعديل مسار طيران',
  'profile.addgatewaydescription':
    'في هذا النموذج، يمكنك تسجيل مسار الطيران الذي تريده. بعد التسجيل، سيتم إجراء عمليات البحث وفقًا لمسارات الطيران المسجلة',
  'profile.editgatewaydescription':
    'في هذا النموذج، يمكنك تعديل مسار الطيران الذي تريده. بعد التعديل، سيتم إجراء عمليات البحث وفقًا لمسارات الطيران المسجلة',
  'profile.gatewayroutes': 'مسارات الطيران',
  'profile.airlinecode': 'كود شركة الطيران',
  'profile.internalcode': 'الكود الداخلي',
  'profile.weekdays': 'أيام الأسبوع',
  'profile.known': 'معروف',
  'profile.unknown': 'غير معروف',
  'profile.airlinestatus': 'حالة شركة الطيران',
  'profile.allroutes': 'جميع المسارات',
  'profile.selectoriginanddestination': 'اختيار المنشأ والوجهة',
  'profile.siti': 'سيتي',
  'profile.sito': 'سيتو',
  'profile.soti': 'سوتي',
  'profile.soto': 'سوتو',
  'profile.pathchoice': 'اختيار المسار',
  'profile.submiteditgateway': 'تأكيد تعديل المسار',
  'profile.submitaddgateway': 'تأكيد إضافة المسار',
  'profile.selectflightsdays': 'اختيار أيام الطيران',
  'profile.departureflightcity': 'مدينة مغادرة الطيران',
  'profile.arrivalflightcity': 'مدينة وصول الطيران',
  'profile.ascinternalcode': 'ترتيب تصاعدي للكود الداخلي',
  'profile.descinternalcode': 'ترتيب تنازلي للكود الداخلي',
  'profile.ascairlinecode': 'ترتيب تصاعدي لكود شركة الطيران',
  'profile.descairlinecode': 'ترتيب تنازلي لكود شركة الطيران',
  'profile.addgatewaysuccessfully': 'تم تسجيل مسار الطيران بنجاح',
  'profile.editgatewaysuccessfully': 'تم تعديل مسار الطيران بنجاح',
  'profile.addcustomerduplicated': 'العميل المطلوب مسجل بالفعل',
  'profile.sendfile': 'إرسال إيصال بنكي',
  'profile.sendfiles': 'إرسال إيصالات بنكية',
  'profile.factorestartdate': 'تاريخ بدء الفاتورة',
  'profile.factoreenddate': 'تاريخ انتهاء الفاتورة',
  'profile.factoredate': 'تاريخ الفاتورة',
  'profile.allfactors': 'جميع الفواتير',
  'profile.walletnotenough': 'رصيد المحفظة غير كافٍ',
  'profile.approvePrice': 'السعر المعتمد',
  'profile.oldsecondpassword': 'كلمة المرور الثانية القديمة',
  'profile.setSecondPasswordInfo':
    'إذا كنت تقوم بتعيين كلمة المرور الثانية لأول مرة، فلا حاجة لإدخال هذا الحقل.',
};
